import { render } from "./DrawerCard.vue?vue&type=template&id=b9fc9346&scoped=true"
const script = {}

import "./DrawerCard.vue?vue&type=style&index=0&id=b9fc9346&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9fc9346"]])

export default __exports__